// The stock side of a refund (F-CTRL-N74): for each refunded line, put the
// stock back, or record it as wasted (eaten, binned, sent back). Pure, so the
// dialog's payload is tested without rendering it.
import type { CreditNoteStockAction } from '@/types'
import { VOID_OUTCOME_REASONS } from '@/lib/void-reasons'

export type RefundStockChoice = 'restock' | 'wasted'

export interface RefundStockLine {
  order_item_id?: string
  refund_quantity: number
  stock: RefundStockChoice
  waste_reason?: string
}

/** Reasons a refunded dish is not going back on the shelf. */
export const REFUND_WASTE_REASONS = VOID_OUTCOME_REASONS.wasted

export function refundStockPayload(lines: RefundStockLine[]): CreditNoteStockAction[] {
  return lines
    .filter((l) => l.order_item_id && l.refund_quantity > 0)
    .map((l) => ({
      order_item_id: l.order_item_id!,
      quantity: l.refund_quantity,
      action: l.stock,
      ...(l.stock === 'wasted' && l.waste_reason ? { reason_code: l.waste_reason } : {}),
    }))
}

/** How many refunded units will NOT go back in stock. */
export function wastedRefundUnits(lines: RefundStockLine[]): number {
  return lines.reduce((n, l) => n + (l.stock === 'wasted' ? l.refund_quantity : 0), 0)
}
